import { Moment } from 'moment';

import { makeMoment, makeUnix } from './Model';

export class MemberDashboardSkilled {
  businessDaysSinceEndDate?: number;

  closedAt?: Moment;

  endDate?: Moment;

  episodeDuration?: number;

  startDate?: Moment;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.closedAt = makeUnix(obj.closedAt);
    this.endDate = makeMoment(obj.endDate);
    this.startDate = makeMoment(obj.startDate);
  }

  get status() {
    return this.closedAt ? 'CLOSED' : 'OPEN';
  }
}

export default MemberDashboardSkilled;
